<ng-select
  class="custom"
  [virtualScroll]="true"
  [placeholder]="placeholder"
  [items]="$loadedList | async"
  [compareWith]="compare"
  [typeahead]="typeahead"
  [loading]="$loading | async"
  (change)="change($event)"
  (scrollToEnd)="loadMore()">
  <ng-template ng-header-tmp>
    <small class="form-text text-muted">Found {{ total }} terminals</small>
  </ng-template>
  <ng-template ng-label-tmp let-item="item">
    {{ item.serialNumber }}{{ ' (' + item.domain + ')' }}
  </ng-template>
  <ng-template ng-option-tmp let-item="item">
    {{ item.serialNumber }}{{ ' (' + item.domain + ')' }}
  </ng-template>
</ng-select>
